module.exports = __webpack_public_path__ + "img/border_Ring2.ecbd37e7.svg";